(function (angular) {
    'use strict';

    angular.module('chat2')

        /**
         * Minimal service to share chat related date between controllers ...
         * Currently just sharing the teams 
         */
        .factory('sharedChatDataService', [function () {

            var fac = {
                teams: undefined,
                participantProfileId: undefined,
            };

            return fac;

        }]);

})(window.angular);